module.exports = __webpack_public_path__ + "static/media/elixir-digital-signages.b18b2857.pdf";